export const VALID_LANGUAGES = ['de', 'fr', 'it', 'en'] as const;
